import React from 'react';
import {Card} from "/src/_v2/ui/patterns/Card";

import {Section} from "/src/_v2/ui/layout/Section";
import {Container} from "/src/_v2/ui/layout/Container";

import {SectionHeader} from "/src/_v2/ui/patterns/SectionHeader";


export const AdvantagesSection = ({data, suptitleColor = "pink"}) => {

  return data && (
    <Section>
      <Container className={`tw:space-y-40 tw:md:space-y-64`}>
        <SectionHeader index={data.number} suptitle={data.suptitle} title={data.title} text={data.text}
                       color={suptitleColor}/>

        {data?.items?.length > 0 && (
          <div className="tw:xl:grid tw:xl:grid-cols-12 tw:xl:gap-24">
            <div className="tw:xl:col-span-10 tw:xl:col-start-2">
              <div className="tw:grid tw:gap-16 tw:md:gap-24 tw:md:grid-cols-2 tw:lg:grid-cols-3">
                {data.items.map((item, index) => (
                  <React.Fragment key={index}>
                    <Card
                      color={item.color}
                      title={item.title}
                      text={item.text}
                    />
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}
      </Container>
    </Section>
  );
};
